import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { fontFace, hideVisually } from 'polished';
import { css } from 'styled-components';
/**
 * DEPRECATED
 * Use polished instead: https://polished.js.org/docs/#hidevisually
 * For backwards compatibility, we still offer our own export.
 */

export var visuallyHidden = hideVisually();
var defaultFontFormats = ['woff2', 'woff'];
export function globalFontFaces(_ref) {
  var theme = _ref.theme;

  if (theme && theme.fonts) {
    return theme.fonts.map(font => fontFace(_objectSpread({
      fontDisplay: 'fallback',
      fileFormats: defaultFontFormats
    }, font)));
  }
} // Use a more modern inheritance-based box-sizing setting:
// https://css-tricks.com/inheriting-box-sizing-probably-slightly-better-best-practice/

export var globalBorderBox = css(["\n  html {\n    box-sizing: border-box;\n  }\n\n  *,\n  *:before,\n  *:after {\n    box-sizing: inherit;\n  }\n"]);
export var globalReset = css(["\n  html,\n  body,\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  p,\n  ul,\n  ol,\n  li,\n  dl,\n  dd,\n  form,\n  fieldset,\n  label {\n    margin: 0;\n    padding: 0;\n  }\n"]);

function camelToHyphen(str) {
  return str.replace(/[A-Z]/g, function (m) {
    return '-' + m.toLowerCase();
  }).toLowerCase();
} // Simple cache for the expensive part of `objectToMediaQuery` below.


var mediaQueryCache = new Map();
export function objectToMediaQuery(query) {
  if (typeof query === 'string' || !query) {
    return query;
  }

  var cacheKey = JSON.stringify(query);
  var string = mediaQueryCache.get(cacheKey);

  if (string == null) {
    string = Object.keys(query).map(name => {
      var feature = camelToHyphen(name);
      var value = query[name];

      if (typeof value === 'boolean') {
        return value ? feature : "not ".concat(feature);
      }

      if (typeof value === 'number' && /[height|width]$/.test(feature)) {
        value = "".concat(value, "px");
      }

      return "(".concat(feature, ": ").concat(value, ")");
    }).join(' and ');
    mediaQueryCache.set(cacheKey, string);
  }

  return string;
}
export function getDesktopMediaQuery(theme) {
  var _theme$breakpoints = theme.breakpoints,
      mobile = _theme$breakpoints.mobile,
      desktop = _theme$breakpoints.desktop;

  if (desktop) {
    return objectToMediaQuery(desktop);
  } // Invert the mobile media query with `not`.


  return "not all and ".concat(objectToMediaQuery(mobile));
}
/**
 * Media query template that renders only on mobile sizes.
 * Use like:
 *   ${mobile`color: black;`}
 */

export function mobile() {
  return css(["\n    @media ", " {\n      ", ";\n    }\n  "], props => objectToMediaQuery(props.theme.breakpoints.mobile), css(...arguments));
}
/**
 * Media query template that renders only on desktop sizes.
 * Use like:
 *   ${desktop`color: black;`}
 */

export function desktop() {
  return css(["\n    @media ", " {\n      ", ";\n    }\n  "], props => getDesktopMediaQuery(props.theme), css(...arguments));
}